const axios = require('axios');
export function getMetaByType(type) {
  return new Promise(function (resolve, reject) {
    console.log("getMatasByType ")
    axios.get(process.env.API_URL + '/meta/type/' + type, {
      headers: {
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("getMatasByType response");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        reject()
      });
  })
}



// WEBPACK FOOTER //
// ./src/api/meta.js